import { FC } from 'react'
import styled from '@emotion/styled'
import { OpenInNew } from '@emotion-icons/material-rounded/OpenInNew'
import { IconButton, Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { FlexRow } from 'src/components/flex-containers'
import { DarkTooltip } from 'src/components/tooltip/dark-tooltip'
import { SquareIcon } from 'src/components/icons/square-icon'
import { CircleIcon } from 'src/components/icons/circle-icon'

const Container = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`

const Content = styled.div<{ fullWidth: 1 | 0 }>`
  display: flex;
  flex-direction: column;
  max-width: ${(props) => (props.fullWidth ? '100%' : '88%')};
  flex: 1;
  * {
    max-width: ${(props) => (props.fullWidth ? 320 : 280)}px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

type SidebarResultOverlayHeaderProps = {
  title: string
  subtitle: string
  icon: JSX.Element
  iconBgColor: string
  iconBorderColor?: string
  extraContent?: JSX.Element
  link?: string
  iconShape?: 'circle' | 'square'
  iconSize?: number
}

export const SidebarResultOverlayHeader: FC<SidebarResultOverlayHeaderProps> = ({
  icon,
  iconBgColor,
  iconBorderColor,
  subtitle,
  title,
  extraContent,
  link,
  iconShape = 'circle',
  iconSize = 32,
}) => {
  const onOpenLink = () => {
    window.open(link, '_blank')
  }
  return (
    <Container>
      <FlexRow gap={Shapes.spacing[2]}>
        {iconShape === 'circle' && (
          <CircleIcon
            color={iconBgColor}
            size={iconSize}
            style={{ border: iconBorderColor ? `2px solid ${iconBorderColor}` : 'none' }}>
            {icon}
          </CircleIcon>
        )}
        {iconShape === 'square' && (
          <SquareIcon
            color={iconBgColor}
            size={iconSize}
            style={{ border: iconBorderColor ? `2px solid ${iconBorderColor}` : 'none' }}>
            {icon}
          </SquareIcon>
        )}
        <Content fullWidth={link ? 0 : 1}>
          <Typography color={Colors.neutral900} variant="title2" noWrap>
            {title}
          </Typography>
          <Typography color={Colors.neutral500} variant="textmdm" noWrap>
            {subtitle}
          </Typography>
          {extraContent}
        </Content>
      </FlexRow>
      {link && (
        <DarkTooltip title="View in new tab">
          <IconButton onClick={onOpenLink}>
            <OpenInNew size={16} />
          </IconButton>
        </DarkTooltip>
      )}
    </Container>
  )
}
